import * as React from "react";
import { FileAttachment } from "webportalclient";

import { ErrorBoundary } from "../../../errors/ErrorBoundary";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../../misc/api/WebPortalTokenClient";
import { AttachmentRelatesTo, FileAttachmentsTableMode } from "../../models";
import FileAttachmentsTable from "./FileAttachmentsTable";

export interface FileAttachmentsViewerProps {
    title: string;
    attachmentRelatesTo: AttachmentRelatesTo;
    relatedEntityId: number;
}

const FileAttachmentsViewer = (props: FileAttachmentsViewerProps) => {
    const [fileAttachments, setFileAttachments] = React.useState<FileAttachment[]>([]);
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const [loading, setLoading] = React.useState(true);

    const loadAttachments = async () => {
        const fileAttachmentsResponse = await client.client.getFileAttachments(undefined, `relatedEntityId eq ${props.relatedEntityId}`, undefined, "file");

        if (fileAttachmentsResponse) {
            setFileAttachments(fileAttachmentsResponse.value);
            setLoading(false);
        }
    }

    React.useEffect(() => {
        loadAttachments();
    }, [client.client]);

    return (
        <div className="fileAttachmentsUploader col-lg-12">
            <ErrorBoundary>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title pull-left heading">
                            {props.title} {`(${fileAttachments.length})`}
                        </h3>
                        <span className="clearfix" />
                    </div>
                    <div className="panel-body">
                        {loading ? (
                            <div className="col-lg-12 text-center">
                                Loading file attachments...
                            </div>
                        ) : fileAttachments &&
                            fileAttachments.length > 0 ? (
                            <FileAttachmentsTable
                                legacyClient={legacyClient}
                                fileAttachments={fileAttachments.map(fa => fa.file)}
                                mode={FileAttachmentsTableMode.ListOnly}
                            />
                        ) : (
                            <div className="col-lg-12 text-center">
                                No file attachments were found.
                            </div>
                        )}
                    </div>
                </div>
            </ErrorBoundary>
        </div>
    );
}

export default FileAttachmentsViewer;
